import { OrdersBasketInteractionToolbarComponent } from 'components/Workspaces/OrdersBasket/OrdersBasketInteractionToolbar/OrdersBasketInteractionToolbar';
import {
  OrdersBasketToolbarDispatchProps,
  OrdersBasketToolbarOwnProps,
  OrdersBasketToolbarStateProps,
} from 'components/Workspaces/OrdersBasket/Toolbar/OrdersBasketToolbar.models';
import type { MapDispatchToPropsFunction, MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  canOrdersBasketSelectedFormsBeBooked,
  canOrdersBasketSelectedFormsBeCanceled,
  canOrdersBasketSelectedFormsBeDeleted,
  getOrdersBasketNumberOfSelectedFormsByProductSubType,
} from 'state/orders-basket/selectors';
import {
  ordersBasketAllFormsUnselectedThunk,
  ordersBasketFormsImportThunk,
  ordersBasketSelectedFormsCancellationRequestedThunk,
  ordersBasketSelectedFormsDeletionRequestedThunk,
  ordersBasketSelectedFormsExecutionRequestedThunk,
} from 'state/orders-basket/thunks';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export const mapStateToProps: MapStateToProps<OrdersBasketToolbarStateProps, OrdersBasketToolbarOwnProps, AppState> = (
  state: AppState,
  ownProps: OrdersBasketToolbarOwnProps,
): OrdersBasketToolbarStateProps => {
  const productVariation = { productSubType: ownProps.productSubType, productType: ownProps.productType };
  const numberOfSelectedForms = getOrdersBasketNumberOfSelectedFormsByProductSubType(state, productVariation);
  return {
    numberOfFormsSelected: numberOfSelectedForms,
    canCancelSelectedItems: canOrdersBasketSelectedFormsBeCanceled(state, productVariation),
    canDeleteSelectedItems: canOrdersBasketSelectedFormsBeDeleted(state, productVariation),
    canBookSelectedItems: canOrdersBasketSelectedFormsBeBooked(state, productVariation),
  };
};

export const mapDispatchToProps: MapDispatchToPropsFunction<
  OrdersBasketToolbarDispatchProps,
  OrdersBasketToolbarOwnProps
> = (dispatch: ThunkDispatch, ownProps: OrdersBasketToolbarOwnProps): OrdersBasketToolbarDispatchProps => ({
  onDelete() {
    dispatch(
      ordersBasketSelectedFormsDeletionRequestedThunk({
        productSubType: ownProps.productSubType,
        productType: ownProps.productType,
      }),
    );
  },
  onBook() {
    dispatch(
      ordersBasketSelectedFormsExecutionRequestedThunk({
        productSubType: ownProps.productSubType,
        productType: ownProps.productType,
      }),
    );
  },
  onCancel() {
    dispatch(
      ordersBasketSelectedFormsCancellationRequestedThunk({
        productSubType: ownProps.productSubType,
        productType: ownProps.productType,
      }),
    );
  },
  onImport(identifiers: string[]) {
    dispatch(
      ordersBasketFormsImportThunk(identifiers, {
        productSubType: ownProps.productSubType,
        productType: ownProps.productType,
      }),
    );
  },
  onClearSelection() {
    dispatch(
      ordersBasketAllFormsUnselectedThunk({
        productSubType: ownProps.productSubType,
        productType: ownProps.productType,
      }),
    );
  },
});

export const OrdersBasketInteractionToolbar = connect<
  OrdersBasketToolbarStateProps,
  OrdersBasketToolbarDispatchProps,
  OrdersBasketToolbarOwnProps,
  AppState
>(
  mapStateToProps,
  mapDispatchToProps,
)(OrdersBasketInteractionToolbarComponent);
